import { WebPlugin } from '@capacitor/core';
export class ActiveSubscriptionsCounterWeb extends WebPlugin {
    async getActiveSubscriptionsCount() {
        throw new Error('Active Subscriptions Counter plugin is not supported on web platform. Use iOS or Android.');
    }
}
//# sourceMappingURL=web.js.map